module.exports = __webpack_public_path__ + "img/set.4b03baa6.png";